import type { Debt } from './debt.types'

export const loanAnchorId = (publicLoanNumber: number) => `lan-${publicLoanNumber}`

// Municipality and designation read as one name ("YSTAD MAJBLOMMAN 20"), uppercased as in the land register.
export const collateralLabel = ({ address, housingAssociation, propertyLabel }: Debt['collateralProperty']) => {
  if (housingAssociation?.name) {
    const { name, organisationNumber, housingAssociationApartmentNumber } = housingAssociation
    const orgNr = organisationNumber || 'org nr saknas'
    const lgh = housingAssociationApartmentNumber || 'saknas'
    return `${name} (${orgNr}) lägenhet ${lgh}`.toUpperCase()
  }
  return (propertyLabel ? `${address.municipality.name} ${propertyLabel}` : address.municipality.name).toUpperCase()
}
